export default "__VITE_ASSET__Bop38Zy8__"